// extracted by mini-css-extract-plugin
export default {"recentPosts":"RecentPosts_recentPosts__7axhd","title":"RecentPosts_title__Km0uQ","list":"RecentPosts_list__eNx5o","article":"RecentPosts_article__y2Q2w"};